export function cancel ({id, uid, name}) {
  let eventName

  if (id) {
    eventName = 'Connect Edit Cancel'
  } else {
    eventName = 'Connect Create Cancel'
  }
  const body = {
    'App Name': name,
    'App ID': uid
  }
  clevertap.event.push(eventName, body)
  mixpanel.track(eventName, body)
}

export function next ({step, id}) {
  const curStep = step + 1
  let eventName
  if (id) {
    eventName = getNextEventNameByStep({curStep: curStep, action: 'Edit'})
  } else {
    eventName = getNextEventNameByStep({curStep: curStep, action: 'Create'})
  }
  clevertap.event.push(eventName)
  mixpanel.track(eventName)
}

export function back ({step, id}) {
  let eventName
  if (id) {
    eventName = getBackEventNameByStep({curStep: step, action: 'Edit'})
  } else {
    eventName = getBackEventNameByStep({curStep: step, action: 'Create'})
  }
  clevertap.event.push(eventName)
  mixpanel.track(eventName)
}

export function uploadScreenshot ({step, id, countImages = 0}) {
  let eventName
  if (id) {
    eventName = 'Connect Edit Screenshot Upload 1'
  } else {
    eventName = 'Connect Create Screenshot Upload 2'
  }
  clevertap.event.push(eventName)
  mixpanel.track(eventName)
}

export function uploadScreenshotFailed ({step, id}) {
  let eventName
  if (id) {
    eventName = 'Connect Edit Screenshot Upload Failed'
  } else {
    eventName = 'Connect Create Screenshot Upload Failed'
  }
  clevertap.event.push(eventName)
  mixpanel.track(eventName)
}

export function confirm ({id, uid, name}) {
  let confirmMessage
  if (id) {
    confirmMessage = `Connect Edit Confirmed`
  } else {
    confirmMessage = 'Connect Create Confirmed'
  }
  const body = {
    'App Name': name,
    'App ID': uid
  }
  clevertap.event.push(confirmMessage, body)
  mixpanel.track(confirmMessage, body)
}

export function breadcrumbStatus ({id}) {
  let eventName
  if (id) {
    eventName = 'Connect Edit Breadcrumb'
  } else {
    eventName = 'Connect Create Breadcrumb'
  }
  clevertap.event.push(eventName)
  mixpanel.track(eventName)
}

function getNextEventNameByStep ({curStep, action}) {
  let eventName
  switch (curStep) {
    case 1:
      eventName = `Connect ${action} Credentials Next`
      break
    case 2:
      eventName = `Connect ${action} Scope Next`
      break
    case 3:
      eventName = `Connect ${action} App Information Next`
      break
    default:
      eventName = `Connect Step ${curStep} Next`
  }

  return eventName
}

function getBackEventNameByStep ({curStep, action}) {
  let eventName
  switch (curStep) {
    case 2:
      eventName = `Connect ${action} Scope Back`
      break
    case 3:
      eventName = `Connect ${action} App Information Back`
      break
    case 4:
      if (action === 'Edit') {
        eventName = `Connect ${action} Screenshot Upload Back`
      } else {
        eventName = `Connect ${action} Screenshot Back`
      }
      break
    default:
      eventName = `Connect Step ${curStep} Back`
  }

  return eventName
}



// WEBPACK FOOTER //
// app/javascript/components/mixpanel/oauth/form.js